import { MenuItem, TextField } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { availableLanguagesMapping } from 'c1-i18n'

const useStyles = makeStyles(theme => ({
  listItem: {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    lineHeight: '1.5em',
    minHeight: 24,
  },
}))

interface LanguageDropdownProps {
  language: string,
  onChange: (lang: string) => void,
}

export function LanguageDropdown({ language, onChange }: LanguageDropdownProps) {
  const classes = useStyles()
  return (
    <TextField
      id="tenant-dropdown"
      select
      value={language}
      onChange={event => onChange(event.target.value)}
      auto-qa-id={'Language-Dropdown'}
      data-testid={'Language-Dropdown'}
      SelectProps={{
        MenuProps: {
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'left',
          },
        },
      }}
    >
      {availableLanguagesMapping.map(lang => (
        <MenuItem
          data-testid={`LanguageSelector-${lang.id}`}
          key={lang.id}
          value={lang.id}
          className={classes.listItem}
        >
          {lang.name}
        </MenuItem>
      ))}
    </TextField>
  )
}
